import {v4} from 'uuid';
import {budgetDefultValue} from '@mobi-components/amex-bluesky-components';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import {travlersDefaultValue} from '@common/travelers-filter/travelers.types';
import {TripCategory, TripFocus} from '@common/filter/trip-category-filter/trip-options';
import {IStore} from './global.types';
import {TripWayTypes} from '@/views/amex/app-types';

/* eslint-disable */
const defaultFlightIcon = require('@components/svg/icon-flights.svg');
const defaultStayIcon = require('@components/svg/stay.svg');
const defaultExpIcon = require('@components/svg/marker2.svg');
/* eslint-enable */

export const fallbackImgs = {
  stayImg: defaultStayIcon,
  flightImg: [defaultFlightIcon],
  expImg: [defaultExpIcon],
};

export const defaultOrigin = {
  id: 'ffcb602a-96e3-331f-953f-fb8876d86d87',
  lat: 1.29378,
  lng: 103.853256,
  name: 'Singapore',
  time_zone: 'Asia/Singapore',
  type: '',
  allowed_modes: [],
};

export const defaultDestination = {
  name: '',
  id: '',
  lat: 0,
  lng: 0,
  time_zone: '',
  allowed_modes: [],
  type: '',
};

export const initialState: IStore = {
  bookedActivities: {},
  origin: null,
  destination: null,
  userId: v4(),
  problemId: v4(),
  selectedTrip: '',
  recommendationDetails: {},
  favorites: {},
  solutionResponse: null,
  isSolutionLoading: true,
  alternatives: {},
  myTrips: [],
  manualActivities: [],
  tripContext: '',
  sourcePOIs: [],
  alternativeSolutions: {},
  themeTrips: [],
  tripPrice: [],
  tripSuggestions: [],
  // groupBudget: {
  //   ...budgetDefultValue,
  // },
  // destBudget: {
  //   ...budgetDefultValue,
  // },
  solutionImg: '',
  destName: '',
  solutionBudget: {
    ...budgetDefultValue,
  },
  selectedSolutionFilters: [],
  availableSolutionFilters: [],
  isSolutionSustanable: false,
  destOptions: {},
  nearbyLocations: null,
  solutionStart: 0,
  solutionEnd: 0,
  solutionTravelers: travlersDefaultValue,
  availableTripOptions: [],
  selectedTheme: '',
  recommendationsBlackList: null,
  isRecommendationsLoading: true,
  initiallySelectedFilters: [],
  fallbackImgs,
  solutionName: '',
  tripCategory: TripCategory.CUSTOM,
  tripFocus: TripFocus.POPULAR,
  tripType: TripWayTypes.roundTrip,
  budgetPreferences: {
    goalBudget: 'Mid Range',
    nightlyStayBudget: '$100-200',
    experienceBudget: '$200-400',
  },
  [UserActivityCategoryEnum.ACCOMMODATION]: [
    {title: 'Min Star Rating', value: null},
    {title: 'Min Review Count', value: null},
  ],
  [UserActivityCategoryEnum.DINING]: [
    {title: 'Min Star Rating', value: null},
    {title: 'Min Review Count', value: null},
    {title: 'Price Rating', value: null},
    {title: 'Dietary', value: null},
    {title: 'Open Hours', value: null},
    {title: 'Reservable', value: null},
  ],
  [UserActivityCategoryEnum.EXPERIENCE]: [
    {title: 'Min Star Rating', value: null},
    {title: 'Min Review Count', value: null},
    {title: 'Open Hours', value: null},
  ],
};
